import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import * as yup from "yup";
import { RoleDto } from "../../../services/dto";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface RoleFormProps {
  data?: RoleDto | undefined;
  loading?: boolean;
  show: boolean;
  onHide: () => void;
  onSave: (values: any) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required."),
  display: yup.string().required("Display is required."),
});

export const RoleForm = (props: RoleFormProps) => {
  const title: string =
    StringHelper.whenNullOrEmpty(props.data?.id, Constants.emptyGuid) ===
    Constants.emptyGuid
      ? "New Role"
      : "Edit Role";

  const onSubmit = (data: RoleDto) => {
    return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      title={title}
      initialValues={props.data ?? {}}
      validationSchema={validationSchema}
      on_Submit={onSubmit}
      enableReinitialize
    >
      <Form.Text
        name="name"
        placeholder="Enter text"
        label="Name"
        isLoading={props.loading}
      />
      <Form.Text
        name="display"
        placeholder="Enter text"
        label="Display"
        isLoading={props.loading}
      />
    </Drawer.Form>
  );
};
